import AppLayout from "../components/common/AppLayout";

export default function UsuariosPage() {
    return (
        <AppLayout title="Usuarios">
            <div className="card-panel">
                <h3>Usuarios y permisos</h3>
                <p>Aquí irá la administración de usuarios, roles y permisos.</p>
            </div>
        </AppLayout>
    );
}